module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practiceAreas"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("PRACTICE AREAS")])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('span', {
    staticClass: "plusActive"
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification "
  }, [_c('ul', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('li', [_vm._v("Intellectual Property")]), _vm._v(" "), _c('li', [_vm._v("Information Technology and E-Commerce")]), _vm._v(" "), _c('li', [_vm._v("Domain Names and Telecommunication")]), _vm._v(" "), _c('li', [_vm._v("Data Privacy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Maritime and Transportation")]), _vm._v(" "), _c('li', [_vm._v("Aviation Law")]), _vm._v(" "), _c('li', [_vm._v("Customs and Ports")]), _vm._v(" "), _c('li', [_vm._v("Work and Residence Permits")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-left is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Litigation and Commercial Disputes")]), _vm._v(" "), _c('li', [_vm._v("Contracts Law")]), _vm._v(" "), _c('li', [_vm._v("Real Property")]), _vm._v(" "), _c('li', [_vm._v("Construction Law")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Start-Ups and International Investments")]), _vm._v(" "), _c('li', [_vm._v("Permits, Licences and Authorization")]), _vm._v(" "), _c('li', [_vm._v("Media, Entertainment and Fashion")]), _vm._v(" "), _c('li', [_vm._v("Sports Law")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2202cf1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/practice-areas.vue
// module id = 126
// module chunks = 0